import { Badge, Tab, Tabs } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation, WithTranslation } from 'react-i18next'
import { matchPath, useLocation } from 'react-router'
import { NavigationItem } from '../../../containers/Navigation/types'
import { isNumStep } from '../../../utils/apartments'

interface MenuItemsProps extends WithTranslation {
  navigate: (arg: any) => void
  openDialog: (arg: any) => void
  navItems: NavigationItem[]
  currentPath: string
  classes: any
  unreadMessages: number
}

const tabStyles = (theme: any) => ({
  root: {
    backgroundColor: 'inherit',
    height: '69px'
  },
  wrapper: {
    padding: '0 34px',
    borderRight: '1px solid #65AB5B',
    borderLeft: '1px solid #65AB5B',
    '&:last-child': {
      borderRight: 'none'
    }
  }
})

const getContextHighlightedIndex = {
  '/overview': 0,
  '/applications': 1,
  '/messages': 2,
  '/showings/overview': 3,
  '/apartments': 4,
  '/profile': 5
}
const getHighlightedIndex = {
  '/apartments': 1,
  '/messages': 0,
  '/profile': 2
}
const StyledTab = withStyles({
  selected: {
    background: '#3f7c36',
    padding: '0 35px !important',
    borderRight: 'none !important',
    borderLeft: 'none !important'
  }
})((props: any) => <Tab variant='fullWidth' {...props} />)

const NavTabs = ({
  navigate,
  navItems,
  currentPath,
  classes,
  unreadMessages,
  t
}: MenuItemsProps) => {
  const safeUnreadMessages = Number.isFinite(unreadMessages) ? unreadMessages : 0
  const mathcedUrl: any = matchPath(window.location.pathname, {
    path: '/users/:userId/apartments/:apartmentId'
  })
  const location = useLocation()
  const currentKey = navItems.some(({ id }) => id === currentPath)
    ? currentPath
    : ''

  const BadgeIcon = ({ children, rootId }: any) => {
    const showUnreadBadge = safeUnreadMessages > 0
    return (
      <>
        {rootId === '/messages' ? (
          <Badge
            badgeContent={safeUnreadMessages}
            color='secondary'
            invisible={!showUnreadBadge}
          >
            {children}
          </Badge>
        ) : (
          <>{children}</>
        )}
      </>
    )
  }

  const isClientStage = isNumStep(location.pathname, '12')
  const isStepRoute = location.pathname.includes('steps')
  const isApartmentContext =
    mathcedUrl?.params?.apartmentId && mathcedUrl?.params?.userId
  const isProfileRoute = location.pathname.startsWith('/profile')
  const isApartmentStepRoute = /\/(create\/apartment|users\/[^/]+\/apartments\/[^/]+)\/steps\//.test(
    location.pathname
  )

  const selectedValue = isStepRoute
    ? false
    : isApartmentContext
    ? getContextHighlightedIndex[currentKey] ?? false
    : getHighlightedIndex[currentKey] ?? false
  return (
    <Tabs
      value={selectedValue}
      className={classes.root}
    >
      {navItems.map(({ id, label, icon: Icon }) => {
        const showApartmentTab =
          isApartmentContext &&
          !isStepRoute &&
          (id === '/applications' ||
            id === '/showings/overview' ||
            id === '/messages' ||
            id === '/overview' ||
            id === '/apartments')

        const showProfileOrMenu =
          (!isApartmentContext || isStepRoute) &&
          ((isProfileRoute && id === '/apartments') ||
            (isApartmentStepRoute && id === '/apartments') ||
            (!isProfileRoute && !isApartmentStepRoute && id === '/profile'))

        if (showApartmentTab) {
          return (
            <StyledTab
              icon={
                <BadgeIcon rootId={id}>
                  <Icon />
                </BadgeIcon>
              }
              label={t(label)}
              key={id}
              disabled={isClientStage}
              className={classes.wrapper}
              onClick={() => {
                navigate(id === '/apartments' ? '/apartments' : mathcedUrl.url + id)
              }}
            />
          )
        } else if (showProfileOrMenu) {
          const adjustIconMargin = id === '/apartments'
          return (
            <StyledTab
              icon={
                <BadgeIcon rootId={id}>
                  <Icon
                    style={
                      adjustIconMargin ? { marginBottom: '5px', marginTop: '0px' } : {}
                    }
                  />
                </BadgeIcon>
              }
              label={t(label)}
              key={id}
              disabled={isClientStage}
              className={classes.wrapper}
              onClick={() => {
                navigate(id)
              }}
            />
          )
        }
        return null
      })}
    </Tabs>
  )
}
export default withTranslation()(
  withStyles(tabStyles, { withTheme: true })(NavTabs) as any
) as any
